'use client'

import { FC, FormEvent } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { METHOD_2FA_ENUM } from '@/common/constants'
import { Button, Checkbox } from '@/components/commons'
import { yupResolver } from '@hookform/resolvers/yup'

import { FORM_CASE_ENUM } from '../../utils/constants'
import { FormProps, IContactFormProps } from './types'
import { schema } from './utils/validations'

const ContactForm: FC<IContactFormProps> = ({
  contacts,
  sendButtonLoading,
  setIsOpenModal,
  handleSendCode,
  setFormCase,
  setCurrentMethod,
  currentMethod,
}) => {
  const { register, handleSubmit, setValue, trigger, reset } =
    useForm<FormProps>({
      mode: 'all',
      resolver: yupResolver(schema),
    })

  const onSubmit: SubmitHandler<FormProps> = ({ method }) =>
    handleSendCode(method as METHOD_2FA_ENUM)

  function handleCloseModal() {
    reset()
    setCurrentMethod(METHOD_2FA_ENUM.EMAIL)
    setIsOpenModal((prev) => !prev)
  }

  function handleCheckDocument(e: FormEvent<HTMLInputElement>) {
    const value = Number(e.currentTarget.value)
    if (Object.values(METHOD_2FA_ENUM).includes(value)) {
      setCurrentMethod(value)
      setValue('method', value as METHOD_2FA_ENUM)
      trigger('method')
    }
  }

  return (
    <form
      className="flex flex-col w-full bg-white gap-4"
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className="flex flex-col gap-2">
        <p className="prose-body">
          Selecione um contato para receber o código de autenticação.
        </p>
        <div className="flex flex-col gap-2 w-full">
          {[METHOD_2FA_ENUM.EMAIL, METHOD_2FA_ENUM.PHONE].map((method) => (
            <Checkbox
              key={method}
              label={
                method === METHOD_2FA_ENUM.EMAIL
                  ? contacts.email
                  : contacts.celPhoneNumber
              }
              typeBox="radio"
              id={method.toString()}
              value={method}
              checked={currentMethod === method}
              {...register('method', {
                onChange: handleCheckDocument,
                onBlur: handleCheckDocument,
              })}
            />
          ))}
        </div>
      </div>
      <Button
        type="submit"
        text="Enviar código"
        isLoading={sendButtonLoading}
      />
      <div className="flex w-full justify-between gap-4">
        {[
          { text: 'Cancelar', onClick: handleCloseModal },
          {
            text: 'Já tem um código? Clique aqui.',
            onClick: () => setFormCase(FORM_CASE_ENUM.HAS_A_CODE),
          },
        ].map(({ text, onClick }) => (
          <p
            key={text}
            onClick={onClick}
            className="prose-body-small self-end text-grayscale-600 hover:underline cursor-pointer active:scale-95"
          >
            {text}
          </p>
        ))}
      </div>
    </form>
  )
}

export default ContactForm
